import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import { AppDispatchType, RootStateType } from '@store/store';

export const useStoreDispatch = () => useDispatch<AppDispatchType>();
export const useStoreSelector: TypedUseSelectorHook<RootStateType> = useSelector;
